/* eslint-disable react/no-danger */
import React from "react";
import PropTypes from "prop-types";
// eslint-disable-next-line import/no-cycle
import { Link } from "../../sharedComponents/Link";
import { Img } from "../../sharedComponents/Images/Image/Img";
import * as styles from "./BannerExperience.module.scss";

const BannerExperience = ({ image, link, text }) => (
	<div className={styles.bannerExperience}>
		<div className={styles.bannerExperienceImage}>
			{image.url ? (
				<Img alt={image.alt} src={image.url} />
			) : (
				<Img fluid={image.fluid} alt={image.alt} />
			)}
		</div>
		<div className={styles.bannerExperienceContent} dangerouslySetInnerHTML={{ __html: text }} />
		{link.url && (
			<Link
				to={link.url}
				className={styles.bannerExperienceLink}
				target={link?.target}
				externalModalMessage={link?.externalModalMessage}
				onOpenModal={link?.onOpenModal}>
				<span className="sr-only">{link?.linkText}</span>
			</Link>
		)}
	</div>
);

BannerExperience.propTypes = {
	image: PropTypes.shape({
		url: PropTypes.string,
		alt: PropTypes.string,
		fluid: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
	}).isRequired,
	link: PropTypes.shape({
		url: PropTypes.string,
		linkText: PropTypes.string,
		target: PropTypes.string,
		externalModalMessage: PropTypes.string,
		onOpenModal: PropTypes.func,
	}),
	text: PropTypes.string.isRequired,
};

BannerExperience.defaultProps = {
	link: {},
};

export default BannerExperience;
export { BannerExperience };
